module.exports = __webpack_public_path__ + "img/product_service27.e60c9572.png";